import { useState } from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../features/auth/AuthContext'
import { Logo } from './Logo'

export function PublicLayout() {
  const [open, setOpen] = useState(false)
  const { user } = useAuth()
  const close = () => setOpen(false)
  return <div className="site-shell">
    <header className="site-header">
      <div className="container nav-row">
        <Logo />
        <button className="menu-button" aria-expanded={open} aria-controls="public-navigation" onClick={() => setOpen(value => !value)}><span className="sr-only">Toggle navigation</span>☰</button>
        <nav id="public-navigation" className={open ? 'nav-links open' : 'nav-links'} aria-label="Main navigation">
          <NavLink to="/how-it-works" onClick={close}>How it works</NavLink>
          <NavLink to="/reports" onClick={close}>Browse reports</NavLink>
          <NavLink to="/pricing" onClick={close}>Pricing</NavLink>
          <NavLink to="/safety" onClick={close}>Safety</NavLink>
          {user ? <Link className="button button-small" to={user.role === 'admin' ? '/admin' : '/app'} onClick={close}>Open dashboard</Link> : <><NavLink to="/login" onClick={close}>Sign in</NavLink><Link className="button button-small" to="/register" onClick={close}>Protect an item</Link></>}
        </nav>
      </div>
    </header>
    <main id="main-content"><Outlet /></main>
    <footer className="site-footer"><div className="container footer-grid"><div><Logo /><p>Private, practical recovery tools for the belongings that matter.</p></div><div><h2>FindBack</h2><Link to="/features">Features</Link><Link to="/faq">FAQ</Link><Link to="/contact">Contact</Link></div><div><h2>Trust</h2><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><Link to="/safety">Safety</Link></div></div><div className="container footer-base"><span>© {new Date().getFullYear()} FindBack</span><span>Built with privacy by default.</span></div></footer>
  </div>
}

